// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/cancel_subscription.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SubscriptionStatus } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/cancel_subscription.proto.
 */
export const file_vision_billing_v1_cancel_subscription: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vYmlsbGluZy92MS9jYW5jZWxfc3Vic2NyaXB0aW9uLnByb3RvEhhwcm90b3MudmlzaW9uLmJpbGxpbmcudjEicQoZQ2FuY2VsU3Vic2NyaXB0aW9uUmVxdWVzdBJKCgZwYXJhbXMYASABKAsyOi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2FuY2VsU3Vic2NyaXB0aW9uUmVxdWVzdC5QYXJhbXMaCAoGUGFyYW1zIvwBChpDYW5jZWxTdWJzY3JpcHRpb25SZXNwb25zZRJLCgZyZXN1bHQYASABKAsyOy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2FuY2VsU3Vic2NyaXB0aW9uUmVzcG9uc2UuUmVzdWx0GpABCgZSZXN1bHQSSQoTc3Vic2NyaXB0aW9uX3N0YXR1cxgBIAEoDjIsLnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdWJzY3JpcHRpb25TdGF0dXMSOwoXc3Vic2NyaXB0aW9uX3BlcmlvZF9lbmQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wYgZwcm90bzM", [file_vision_billing_v1_vision_billing, file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.billing.v1.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequest = Message<"protos.vision.billing.v1.CancelSubscriptionRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CancelSubscriptionRequest.Params params = 1;
   */
  params?: CancelSubscriptionRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CancelSubscriptionRequest.
 * Use `create(CancelSubscriptionRequestSchema)` to create a new message.
 */
export const CancelSubscriptionRequestSchema: GenMessage<CancelSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_subscription, 0);

/**
 * @generated from message protos.vision.billing.v1.CancelSubscriptionRequest.Params
 */
export type CancelSubscriptionRequest_Params = Message<"protos.vision.billing.v1.CancelSubscriptionRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.CancelSubscriptionRequest.Params.
 * Use `create(CancelSubscriptionRequest_ParamsSchema)` to create a new message.
 */
export const CancelSubscriptionRequest_ParamsSchema: GenMessage<CancelSubscriptionRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_subscription, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.CancelSubscriptionResponse
 */
export type CancelSubscriptionResponse = Message<"protos.vision.billing.v1.CancelSubscriptionResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CancelSubscriptionResponse.Result result = 1;
   */
  result?: CancelSubscriptionResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CancelSubscriptionResponse.
 * Use `create(CancelSubscriptionResponseSchema)` to create a new message.
 */
export const CancelSubscriptionResponseSchema: GenMessage<CancelSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_subscription, 1);

/**
 * @generated from message protos.vision.billing.v1.CancelSubscriptionResponse.Result
 */
export type CancelSubscriptionResponse_Result = Message<"protos.vision.billing.v1.CancelSubscriptionResponse.Result"> & {
  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionStatus subscription_status = 1;
   */
  subscriptionStatus: SubscriptionStatus;

  /**
   * @generated from field: google.protobuf.Timestamp subscription_period_end = 2;
   */
  subscriptionPeriodEnd?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CancelSubscriptionResponse.Result.
 * Use `create(CancelSubscriptionResponse_ResultSchema)` to create a new message.
 */
export const CancelSubscriptionResponse_ResultSchema: GenMessage<CancelSubscriptionResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_subscription, 1, 0);

